import { cn } from "@/lib/utils";
import { Building } from "iconsax-react";
import { FC, HTMLAttributes, useState } from "react";

type CompanyHeadingProps = HTMLAttributes<HTMLDivElement> & {
  companyName: string;
};

const CompanyHeading: FC<CompanyHeadingProps> = (props) => {
  const [logo, setLogo] = useState<string>("");

  return (
    <div className={cn("flex items-center gap-4", props.className)}>
      <div
        className="relative flex h-12 w-12 shrink-0 items-center justify-center rounded-full border-2 border-[#615CB7] bg-[#615CB7] text-white"
        onClick={() => setLogo("")}
      >
        {logo ? (
          <img
            className="h-full w-full rounded-full object-cover"
            src={logo}
            alt="Logotipo de la empresa"
          />
        ) : (
          <Building size={28} />
        )}
        {/*<div className="absolute -bottom-2 -right-2 flex h-6 w-6 items-center justify-center rounded-full bg-[#9491CF] text-white">
          <Edit2 size={12} />
        </div>*/}
      </div>

      <div className="text-base font-semibold uppercase leading-snug text-[#293038]">
        {props.companyName}
      </div>
    </div>
  );
};

export default CompanyHeading;
